import { createReducer, getUpdater } from '@advanza/advanza_generic'
import { changeEntity, changeFilter, invalidateFilters, receiveList } from './sharedReducerHandlers'

const update = getUpdater()

const handlers = {
    EXPECTATIONSETTINGS_RECEIVE_LIST: receiveList,
    EXPECTATIONSETTINGS_CHANGE_FILTER: changeFilter,
    CHANGE_ENTITY_EXPECTATIONSETTINGS: changeEntity,
    INVALIDATE_EXPECTATIONSETTINGS: invalidateFilters,
    EXPECTATIONSETTINGS_REQUEST: (state) =>
        update(state, {
            isFetching: { $set: true },
        }),
}

const initialState = {
    isFetching: false,
    didInvalidate: false,
    counts: {},
    entities: {},
    result: {},
    filters: {},
}

export default createReducer(initialState, handlers)
